// One phrase for the front door (Story #6712, UX-005 / Rob's decision D1):
// self-serve for individuals, plus a "Talk to us" route for organisations.
// The trial length mirrors TRIAL_DURATION_DAYS in lambda/innovateflow-api/signup/handler.py.
export const OFFER_PHRASE = 'Free 30-day trial \u00b7 no card required'
export const OFFER_CTA = 'Create an account'
export const TALK_TO_US_EMAIL = 'hello@innovateflow.com.au'
export const TALK_TO_US_HREF = `mailto:${TALK_TO_US_EMAIL}?subject=Talk%20to%20us`
